import React, { Component } from "react";
import { List, ListItem, ListItemText, Collapse } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { GetData } from "../../api/service";


export default class LeftPanel extends Component {
  state = {
    tree: [],
    openNodes: {}
  };

  componentDidMount() {
    GetData(`/${this.props.apikey}/programme/tree`).then((resp) => {
      this.setState({ tree: resp });
    });
  }

  toggleNode = (id) => {
    this.setState((prevState) => ({
      openNodes: {
        ...prevState.openNodes,
        [id]: !prevState.openNodes[id]
      }
    }));
  };

  renderTree = (nodes, level = 0) => {
    return nodes.map((node) => {
      const isOpen = this.state.openNodes[node.id] || false;
      const hasChildren = node.children && node.children.length > 0;

      return (
        <div key={node.id}>
          <ListItem
            button
            onClick={() => {
              this.props.onSelect(node);
              if (hasChildren) this.toggleNode(node.id);
            }}
            style={{ paddingLeft: level * 16 }}
          >
            {hasChildren ? (
              isOpen ? <ExpandLess /> : <ExpandMore />
            ) : (
              <span style={{ width: 24 }} />
            )}

            <ListItemText primary={node.title} secondary={node.slug ? `/${node.slug}` : null} />
          </ListItem>

          {hasChildren && (
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              {this.renderTree(node.children, level + 1)}
            </Collapse>
          )}
        </div>
      );
    });
  };

  render() {
    return (
      <List>
        {this.renderTree(this.state.tree)}
      </List>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/AdminProgramme/LeftPanel.js